export default () => {
    const offset = window.innerWidth >= 768 ? 210 : 120;
    window.scrollTo({ top: offset, behavior: 'smooth' });
};
